export default __webpack_public_path__ + "images/vodafone-cash.613b58a1153c13b8f6f77ce3f74637ce.jpeg";